"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_2 = require("@xstate/react");
const providerInfoListBoxMachine_1 = require("../../lib/machines/providerInfoListBoxMachine");
const constants_1 = require("../../lib/constants");
const AnnouncedSearchResultCount_1 = require("../../../AnnouncedSearchResultCount");
const SearchInput_1 = __importDefault(require("../SearchInput"));
const ShowMoreShowLess_1 = __importDefault(require("./ShowMoreShowLess"));
const styles_1 = require("./styles");
const NoResults_1 = __importDefault(require("./NoResults"));
const ProviderInfoListBox = ({ title, searchInputTitle, itemType, items, id, cssClasses, log, showSearch = false, numColumns = 1, message = null, truncateAt = Infinity, showClearSearchIcon = false, showClearSearchButton = true, isV9Profile = false }) => {
    const machine = (0, react_1.useMemo)(() => (0, providerInfoListBoxMachine_1.createInfoBoxMachine)(items, truncateAt, numColumns), []);
    const [state, send] = (0, react_2.useMachine)(machine);
    const { term, columns, filteredItems } = state.context;
    // For triggering analytics event only once when search is used
    const hasLoggedSearch = (0, react_1.useRef)(false);
    const handleSearchTracking = () => {
        if (!hasLoggedSearch.current) {
            log(constants_1.logging.userSearch(id));
            hasLoggedSearch.current = true;
        }
    };
    return (react_1.default.createElement(styles_1.Container, { "data-testid": `ProviderInfoListBox-${id}`, className: cssClasses },
        react_1.default.createElement(styles_1.ColContainerHeader, null, title ? (react_1.default.createElement(styles_1.Col, null,
            react_1.default.createElement(styles_1.Title, { id: `ProviderInfoListBox-title-${id}` }, title))) : null),
        message ? message : null,
        showSearch && (react_1.default.createElement(styles_1.SearchAreaWrapper, null,
            searchInputTitle && (react_1.default.createElement(styles_1.SearchInputTitle, { "data-testid": "search-input-title" }, searchInputTitle)),
            react_1.default.createElement(SearchInput_1.default, { id: `ProviderInfoListBox-${id}`, itemType: itemType || '', value: term, enableClearInput: showClearSearchIcon, onChange: (e) => {
                    handleSearchTracking();
                    send({
                        type: constants_1.events.UPDATE_TERM,
                        data: {
                            term: e.currentTarget.value
                        }
                    });
                }, onCancel: () => {
                    send({ type: constants_1.events.CLEAR_TERM });
                }, isV9Profile: isV9Profile }),
            react_1.default.createElement(AnnouncedSearchResultCount_1.AnnouncedSearchResultCount, { term: term, count: filteredItems.length }))),
        !state.matches(constants_1.states.noResults) && (react_1.default.createElement(styles_1.ColContainer, { className: state.matches(`${constants_1.states.expandable}.${constants_1.states.contracted}`)
                ? 'contracted'
                : '' }, columns.map((columnItems, columnIndex) => (react_1.default.createElement(styles_1.Col, { key: columnIndex },
            react_1.default.createElement(styles_1.ItemList, { "aria-labelledby": `ProviderInfoListBox-title-${id}` }, columnItems.map((item) => {
                return react_1.default.createElement(styles_1.Item, { key: item.name }, item.name);
            }))))))),
        react_1.default.createElement(NoResults_1.default, { showClearSearchButton: showClearSearchButton, term: term, send: send, state: state }),
        react_1.default.createElement(ShowMoreShowLess_1.default, { id: id, state: state, log: log, send: send })));
};
exports.default = ProviderInfoListBox;
//# sourceMappingURL=ProviderInfoListBox.js.map